import './style.css';

import Landing from './landing';

export default Landing;
